const actions = {
	
	CREATE_BEGIN: 'CREATE_BEGIN',
	CREATE_SUCCESS: 'CREATE_SUCCESS',
	CREATE_ERR: 'CREATE_ERR',

	FETCH_DETAIL_BEGIN: 'FETCH_DETAIL_BEGIN',
	FETCH_DETAIL_SUCCESS: 'FETCH_DETAIL_SUCCESS',
	FETCH_DETAIL_ERR: 'FETCH_DETAIL_ERR',

	FETCH_LIST_BEGIN: 'FETCH_LIST_BEGIN',
	FETCH_LIST_SUCCESS: 'FETCH_LIST_SUCCESS',
	FETCH_LIST_ERR: 'FETCH_LIST_ERR',

	UPDATE_BEGIN: 'UPDATE_BEGIN',
	UPDATE_SUCCESS: 'UPDATE_SUCCESS',
	UPDATE_ERR: 'UPDATE_ERR',

	createBegin: () => {
		return {
			type: actions.CREATE_BEGIN,
		};
	},

	createSuccess: (data) => {
		return {
			type: actions.CREATE_SUCCESS,
			data,
		};
	},

	createErr: (err) => {
		return {
			type: actions.CREATE_ERR,
			err,
		};
	},

	fetchDetailBegin: () => {
		return {
			type: actions.FETCH_DETAIL_BEGIN,
		};
	},

	fetchDetailSuccess: (data) => {
		return {
			type: actions.FETCH_DETAIL_SUCCESS,
			data,
		};
	},

	fetchDetailErr: (err) => {
		return {
			type: actions.FETCH_DETAIL_ERR,
			err,
		};
	},

	fetchListBegin: () => {
		return {
			type: actions.FETCH_LIST_BEGIN,
		};
	},

	fetchListSuccess: (data) => {
		return {
			type: actions.FETCH_LIST_SUCCESS,
			data,
		};
	},

	fetchListErr: (err) => {
		return {
			type: actions.FETCH_LIST_ERR,
			err,
		};
	},

	updateBegin: () => {
		return {
			type: actions.UPDATE_BEGIN,
		};
	},

	updateSuccess: (data) => {
		return {
			type: actions.UPDATE_SUCCESS,
			data,
		};
	},

	updateErr: (err) => {
		return {
			type: actions.UPDATE_ERR,
			err,
		};
	},

};

export default actions;
